module.exports = __webpack_public_path__ + "static/img/b3.42159c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b3.png
// module id = BiIA
// module chunks = 1